/*
These should all be pure functions that take in data and return data without mutating anything.
*/

const staticFilterResults = (results, staticFilters) => {
  if (staticFilters.onlyRented === true) {
    results = results.filter(result => result.item.ownership === "rented")
  }
  if (staticFilters.onlyStationary === true) {
    results = results.filter(result => result.isStationary)
  }

  return results
}

const assetFilterResults = (results, assetDeviceTypeFilters) => {
  return (results = results.filter(result =>
    assetDeviceTypeFilters.includes(result.item.assetDeviceType.id)
  ))
}

export const filterBoxesResults = (results, staticFilters, selectedAssets) => {
  let selectedFiltersLength = 0
  let filteredSearchedAssets = results
  const staticFilterValues = Object.values(staticFilters)
  if (staticFilterValues.includes(true)) {
    filteredSearchedAssets = staticFilterResults(
      filteredSearchedAssets,
      staticFilters
    )
    selectedFiltersLength = staticFilterValues.filter(
      staticFilterValue => staticFilterValue === true
    ).length
  }

  if (selectedAssets && selectedAssets.length > 0) {
    filteredSearchedAssets = assetFilterResults(
      filteredSearchedAssets,
      selectedAssets
    )
    selectedFiltersLength += selectedAssets.length
  }

  return {
    selectedFiltersLength,
    filteredSearchedAssets,
  }
}
